export default {
  toasts: {
    hide: {
      success: '%venueName% has been hidden.',
      error: '%venueName% could not be hidden.'
    },
    unhide: {
      success: '%venueName% has been unhidden.',
      error: '%venueName% could not be unhidden.'
    },
    create: {
      success: '%venueName% has been created.',
      error: '%venueName% could not be created.',
    },
    update: {
      success: 'Your changes to the location have been saved.',
      error: '%venueName% could not be updated.',
    },
  },
  actions: {
    hide: 'Hide',
    edit: 'Edit',
    unhide: 'Unhide',
    create: 'Create New Venue',
  },
  filters: {
    visibility: {
      label: 'Visibility',
      options: {
        hidden: 'Hidden',
        visible: 'Visible',
        all: 'All',
      }
    },
    name: {
      label: 'Search',
      placeholder: 'Search location name or address'
    },
    order: {
      label: 'Sort By:',
      options: {
        asc: 'Location Name A-Z',
        desc: 'Location Name Z-A'
      },
    },
    header: 'Filter',
    state: {
      label: 'State'
    },
    clearAll: 'Clear All Filters',
  },
  list: {
    header: 'Locations',
    sortOrder: 'Sort Order',
    clearSort: 'Reset',
    noResultsHeader: 'No Venues Found',
    noResultsBody: 'Empty',

  },
  form: {
    header: {
      create: 'Tell us about your job\'s location',
      edit: 'Edit Location'
    },
    submit: {
      create: 'Create',
      edit: 'Save'
    },
    cancel: 'Cancel',
    name: 'Location Name',
    address: 'Address',
    city: 'City',
    state: 'State',
    zip: 'Zip',
    travelTips: 'Travel Tips and Arrival Instructions',
    locationRadius: 'Location Radius',
    map: 'Check-In Radius',
    mapNote: 'Note: The map is based on the address you entered. Please click and drag the Geo-Fencing to refine and set your check-in area.',
    placeholder: {
      name: 'Enter location name',
      address: 'Street address, suite, unit, building, floor, etc.',
      city: 'Enter city name',
      state: 'Choose a state',
      zip: 'Enter Zip',
      travelTips: 'Enter information you wish to provide Wonoloers about how to get to the venue; public transit, driving directions. You may also provide information on how to access the worksite as well.',
    },
    errors: {
      name: 'Please enter a location name',
      address: 'Please enter an address',
      invalidAddress: 'The address you have entered is invalid, please enter a valid address. Please include building number, street address along with floor number, suite, or room number if appropriate.',
      city: 'Please enter a city name',
      invalidCity: 'The city you have entered is invalid, please enter a valid city name.',
      state: 'Please choose a state',
      travelTips: 'Please enter travel tips',
      duplicateName: 'Sorry that name is already in use'
    }
  },
  modularVenueForm: {
    header: 'Where is the location?',
    streetAddressLabel: 'Street address',
    zipCodeLabel: 'Zip code',
    locationNameLabel: 'Location name',
    locationNameHelperText: 'Enter a unique code and/or name for this Location',
    travelTips: 'Travel tips and arrival instructions',
    clockInRadiusLabel: 'Clock-in radius',
    clockInRadiusDescription: 'This creates a boundary around the location where Wonoloers can clock in and out of their jobs from. You can click and drag the circle to refine your check-in area.',
    arrivalInstructionsHeader: 'What are the arrival instructions for workers?',
    parkingInstructionsLabel: 'Parking instructions',
    parkingInstructionsHelperText: 'Describe any designated areas or locations for parking as well as instructions for entering and exiting.',
    entranceInstructionsLabel: 'Entrance instructions',
    entranceInstructionsHelperText: 'Describe where and how to enter the building as well as any other entry requirements such as security or ID verification.',
    entrancePictures: 'Add image (optional)',
    additionalInstructionsHeader: 'Do you have any additional instructions for accessing location?',
    additionalInstructionsLabel: 'Enter any additional instructions...',
    contactInfoHeader: 'Who is the contact for this location?',
    contactInfoDescription: 'This is the person(s) who the Wonoloer can reach out to for any issues or questions.',
    contactInfoNotice: 'Contact information is hidden from Wonoloers until closer to the job start time.',
    addAContact: 'Add a contact',
    reachedContactLimit: 'You reached the limit of 2 contacts for this location',
    nameLabel: 'Name',
    addPhoto: 'Add photo (optional)',
    createContactModalDescription: 'We will save this contact for future use so you do not have to input information again.',
    editContactButton: 'Edit contact',
    editContactModalHeader: 'Edit contact information',
    removeContactConfirmationHeader: 'Are you sure you want to remove this contact?',
    removeContactConfirmationDescription: 'This contact will still be saved in your system, but it will no longer be associated to this location.',
    removeContactConfirmationButton: 'Yes, remove contact',
    selectContactDescription: 'Select an existing contact or create a new one. We will save this contact for future use on locations.',
    selectContactLabel: 'Contact',
    selectContactPlaceholder: 'Search for a contact',
    createNewDescription: 'Don\'t see the contact you need?',
    createNewButton: 'Create a new contact',
    selectContactSubmitButton: 'Add contact',
    phoneNumber: 'Phone number',
    activeVenueEdittingNotice: 'You are not able to update the address since this location is associated with a job request. You may still adjust your clock-in radius and location name.',
    errors: {
      entranceInstructions: 'Please enter entrance instructions',
      duplicateAddress: 'A location with this street address already exists',
      contacts: {
        name: 'Please enter the contact\'s name',
        lastName: 'Please enter the contact\'s last name',
        contactMethod: 'Please enter the preferred contact method',
        startTime: 'Please enter a start time',
        endTime: 'Please enter an end time',
        phoneNumber: 'Please enter a phone number',
        phoneNumberInvalid: 'Please enter a valid phone number',
        email: 'Please enter an email address',
        communicationPreferenceDetails: 'Please enter the details'
      }
    },
    saveChangesModalTitle: 'Are you sure you want to save these changes?',
    saveChangesModalDescription: 'Wonoloers will be notified of these changes for all %workdays% workday(s).',
    saveChangesConfirm: 'Yes, save changes'
  },
  alerts: {
    update: {
      success: 'Your change was made successfully.',
      error: 'There was a problem submitting your change. Our team has been notified.',
      pending: 'Your request is processing. You\'ll be emailed in a few minutes when it\'s complete '
    }
  },
  merge: {
    modal: {
      header: {
        title: 'Merge Venues',
        subHeader: 'By merging venues, you are replacing those venues across all of your jobs including past, present, and future jobs.'
      },
      content: {
        replace: 'Replace:',
        with: 'with:'
      },
      buttons: {
        merge: 'Replace'
      },
      confirm: {
        title: 'Are you sure?',
        content: 'Once a location is replaced it cannot be restored.'
      },
      dropdown: {
        placeholder: 'Search location name or address'
      }
    },
    toasts: {
      success: 'Your venues have been merged',
      error: 'System error. Please try again later'
    },
  },
  bulkActions: {
    mainButton: 'Bulk Action',
    merge: 'Merge Venues'
  }
};
